import './App.scss';
import Header from '../Tools/Header/Header.jsx';
import Footer from '../Tools/Footer/Footer.jsx';
import Menu from '../Tools/Menu/Menu.jsx';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Offline, Online } from "react-detect-offline";
import Main from './Main.jsx';

// blogs images
import unlock from '../Images/unlock.png'
import reload from '../Images/reload.png'
import Chimney1 from '../Images/Chimney1.jpeg'
import Chimney2 from '../Images/Chimney2.jpeg'
import Chimney3 from '../Images/Chimney3.jpeg'
import Chimney4 from '../Images/Chimney4.jpeg'
import callbtn from '../Images/telephone.png'
import PopUp from '../Tools/PopUp/PopUp.jsx';

function App() {
  const [showMenu, setShowMenu] = useState(false)
  const [showPopUp, setShowPopUp] = useState(false)
  const [showVerify, setShowVerify] = useState(true)
  const [status, setStatus] = useState(true);
  const navigate = useNavigate()
  const location = useLocation()

  const url = new URL(window.location.href);
  const [CitiesData, setCitiesData] = useState({});
  const [CitiePhone, setCitiePhone] = useState(url.searchParams.get('cp') ? url.searchParams.get('cp') : "866-501-1614");
  useEffect(() => {
    (async () => {

      // google //
      if (url.searchParams.get('spg') == "g") {
        const CitiesZipGoogle2 = (await import('./CitiesZipGoogle2.js')).default;
        if (CitiesZipGoogle2.find(a => a.ID == url.searchParams.get('cd'))) {
          const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${CitiesZipGoogle2.find(a => a.ID == url.searchParams.get('cd')).ZC}&key=AIzaSyC_XBMupYyuYy-f1TGdo32rsoHBhSMWPK0&language=en`, { method: 'GET', })
          const data = await res.json()
          // console.log(data.results[0])
          setCitiesData({
            "ID": CitiesData.ID,
            "City":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),
            "Full":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name + ', ' + data.results[0].address_components.find(a => a.types.find(a => a == 'administrative_area_level_1')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),

          })
        } else {
          const CitiesDataGoogle = (await import('./CitiesDataGoogle.js')).default;
          if (CitiesDataGoogle.find(a => a.ID == url.searchParams.get('cd'))) {
            setCitiesData(CitiesDataGoogle.find(a => a.ID == url.searchParams.get('cd')))
          } else {
            setCitiesData({})
          }
        }
      }

      // Microsoft //
      if (url.searchParams.get('spg') == "m") {
        const CitiesZipMS2 = (await import('./CitiesZipMS2.js')).default;
        if (CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd'))) {
          const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd')).ZC}&key=AIzaSyC_XBMupYyuYy-f1TGdo32rsoHBhSMWPK0&language=en`, { method: 'GET', })
          const data = await res.json()
          setCitiesData({
            "ID": CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd')).ID,
            "City":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),
            "Full":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name + ', ' + data.results[0].address_components.find(a => a.types.find(a => a == 'administrative_area_level_1')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),

          })
        } else {
          const CitiesDataMS = (await import('./CitiesDataMS.js')).default;
          if (CitiesDataMS.find(a => a.ID == url.searchParams.get('cd'))) {
            setCitiesData(CitiesDataMS.find(a => a.ID == url.searchParams.get('cd')))
          } else {
            setCitiesData({})
          }
        }
      }



      // const query = '?q={"Name": "Luanda"}'; // Example query
      // const res1 = await fetch(`https://bhocs-10ec.restdb.io/rest/cities${query}`, {
      //   method: 'GET',
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'apikey': '6714a668e2b4472fa2c2d036'
      //   }
      // });
      // const data1 = await res1.json()
      // console.log(data1)



      if (showVerify == true) {
        document.body.style.overflow = "hidden"
        document.body.style.overflow = "scroll"
      } else {
        document.body.style.overflow = "scroll"
      }
      setTimeout(() => {
        const checkpop = localStorage.getItem("showPopUp");
        if (checkpop) {
          setShowPopUp(false)
        } else {
          setShowPopUp(true)
        }
      }, 5000);
      window.addEventListener('online', () => setStatus(true))
      window.addEventListener('offline', () => setStatus(false))
    })();
  }, [showVerify, status]);

  // locationsMain
  const locationsMain = [
    {
      "Location": "Austin",
      "Phone": "737-252-7320",
      "Address": [
        {
          "Location1": "Austin",
          "Address1": "500 E Saint Johns Ave, Austin, TX 78752",
        },
        {
          "Location1": "San Antonio",
          "Address1": "10609 W IH 10, San Antonio, TX 78230",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1ZFzBzklHnjRzKFG32H-Wn9TxmmpdSu8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Chicago",
      "Phone": "872-282-3996",
      "Address": [
        {
          "Location1": "Chicago",
          "Address1": "3257 N Sheffield Ave, Chicago, IL 60657",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1Y2d_hgj3Z2rnaUFE90sd_RmsM456iVI&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Connecticut",
      "Phone": "475-252-4438",
      "Address": [
        {
          "Location1": "Hartford",
          "Address1": "1500 Albany Ave, Hartford, CT 06112",
        },
        {
          "Location1": "Hamden",
          "Address1": "2321 Whitney Ave, Hamden, CT 06518",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1arTs8xd0v35vvinYSHJY5y2cU9EPi7g&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Houston",
      "Phone": "346-585-7546",
      "Address": [
        {
          "Location1": "Houston",
          "Address1": "1808 Antoine Dr, Houston, TX 77055",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1KYM_Tnx3zFBA9vvUnimOYgc3YHLlLBE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Kansas",
      "Phone": "913-733-1556",
      "Address": [
        {
          "Location1": "Kansas",
          "Address1": "455 Nichols Rd, Kansas City, MO 64112",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1cyZUyG54v6vYltik3L6Zbfpd7Cm6gW0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Los Angeles",
      "Phone": "213-376-3626",
      "Address": [
        {
          "Location1": "Valley",
          "Address1": "16311 Ventura Blvd, Encino, CA 91436",
        },
        {
          "Location1": "Los Angeles",
          "Address1": "751 E Olympic Blvd, Los Angeles, CA 90023",
        },
        {
          "Location1": "Riverside",
          "Address1": "3838 Sherman Dr, Riverside, CA 92503",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1igOR7boZkzmdyNwUcncKxxA65IggcHE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Minneapolis",
      "Phone": "651-314-8834",
      "Address": [
        {
          "Location1": "Minneapolis",
          "Address1": "1313 W 26th St, Minneapolis, MN 55405",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=12fYx_1i1hARDMU9SIht0RVfutlIhFfM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New Jersey",
      "Phone": "732-724-1210",
      "Address": [
        {
          "Location1": "Moorestown",
          "Address1": "214 W Main St, Moorestown, NJ 08057",
        },
        {
          "Location1": "Newark",
          "Address1": "831 Broadway, Newark, NJ 07104",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1wCzvOW3l5LHsYiJ8weh2xoTKcaS8nb8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Orlando",
      "Phone": "407-456-7463",
      "Address": [
        {
          "Location1": "Orlando",
          "Address1": "1277 N Semoran Blvd, Orlando, FL 32807",
        },
        {
          "Location1": "Jacksonville",
          "Address1": "1028 Park St, Jacksonville, FL 32204",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1NjUXcA6OX2tJZ-Xht56H0wZZNLiGbeQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Seattle",
      "Phone": "206-558-0610",
      "Address": [
        {
          "Location1": "Seattle",
          "Address1": "425 Pontius Ave N, Seattle, WA 98109",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1wpt9MtPAqDTtBJ8BGNjpjdKnSZ4IYxA&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Saint Louis",
      "Phone": "314-501-5336",
      "Address": [
        {
          "Location1": "Saint Louis",
          "Address1": "12 Maryland, Saint Louis, MO 63108",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=15wIgRS6l1GFxtX5Ongf6ArLwOsAcML0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Tampa",
      "Phone": "813-922-3049",
      "Address": [
        {
          "Location1": "Tampa",
          "Address1": "4115 W Spruce St, Tampa, FL 33607",
        },
        {
          "Location1": "Fort Myers",
          "Address1": "1815 Hough St, Fort Myers, FL 33901",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1sLBr2KXbf8fs1MWdeT9eGkrQDZ-gqXk&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Denver",
      "Phone": "720-790-5165",
      "Address": [
        {
          "Location1": "Denver",
          "Address1": "1415 Park Ave W, Denver, CO 80205",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1-dZYn4IqFRsZTQoHlvmE7CAay5fosYQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Charlotte",
      "Phone": "704-703-4119",
      "Address": [
        {
          "Location1": "Charlotte",
          "Address1": "1500 E 4th, Charlotte, NC 28204",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1mhFU5wqgrPgYF_kqrRbwxfZT9SGr_BI&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Nashville",
      "Phone": "615-560-8426",
      "Address": [
        {
          "Location1": "Nashville",
          "Address1": "2509 Winford Ave, Nashville, TN 37211",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1b1273439kLELw9wSSiqD-_WhlAKGl18&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Dallas",
      "Phone": "214-888-3162",
      "Address": [
        {
          "Location1": "Dallas",
          "Address1": "1346 Motor Cir, Dallas, TX 75207",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1Jq7olr9nIOOlBvrge9gBtQZ1gv38eSk&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Atlanta",
      "Phone": "678-661-6730",
      "Address": [
        {
          "Location1": "Atlanta",
          "Address1": "437 Memorial Dr, Atlanta, GA 30312",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1sIJWXQRLTPmw4YVHmgahsrJWSgd1VEM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Fransisco",
      "Phone": "415-831-7591",
      "Address": [
        {
          "Location1": "San Fransisco",
          "Address1": "2940 16th St, San Francisco, CA 94103",
        },
        {
          "Location1": "Walnut Creek",
          "Address1": "1330 N Broadway, Walnut Creek, CA 94596",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1P2j6c4nBHDRM-AtgEDKq0HXXFq0TcIM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Jose",
      "Phone": "408-809-9705",
      "Address": [
        {
          "Location1": "San Jose",
          "Address1": "770 W Hamilton Ave, Campbell, CA 95008",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1VTJ5eC5cJ1lvDHm3-xJ-8DaTl412cv8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Detroit",
      "Phone": "313-367-4539",
      "Address": [
        {
          "Location1": "Detroit",
          "Address1": "10545 Joy Rd, Detroit, MI 48204",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1EbsUpXTpW8B457T-xz2aBMfyTDb7EYs&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New York",
      "Phone": "516-970-5028",
      "Address": [
        {
          "Location1": "New York",
          "Address1": "51 Bell Blvd, Bayside, NY 11361",
        },
        {
          "Location1": "Farmingdale",
          "Address1": "1111 Broadhollow Rd, Farmingdale, NY 11735",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=17OjSFSNGhqK3w-aOCSkHNgDzV8ybfjc&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Ohio",
      "Phone": "330-302-6783",
      "Address": [
        {
          "Location1": "Fort Wayne",
          "Address1": "10260 Maysville Rd, Fort Wayne, IN 46835",
        },
        {
          "Location1": "Toledo",
          "Address1": "619 Monroe St, Toledo, OH 43604",
        },
        {
          "Location1": "Dayton",
          "Address1": "1024 S Smithville Rd, Dayton, OH 45403",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1T_-ChddVtp0sNncfKQ1_eqiV2h6tCxc&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Philadelphia",
      "Phone": "215-996-7747",
      "Address": [
        {
          "Location1": "Philadelphia",
          "Address1": "25 N American St, Philadelphia, PA 19133",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1D8wzDRrVB_qzrwo_8RkQA30RgZu0Q2I&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Maryland",
      "Phone": "443-331-5559",
      "Address": [
        {
          "Location1": "Wheaton",
          "Address1": "11123 Veirs Mill Rd, Wheaton, MD 20902",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1hFBKavqDPHMd0GUtJ-dU5YcIwaZPHZg&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Miami",
      "Phone": "786-981-9218",
      "Address": [
        {
          "Location1": "Miami",
          "Address1": "310 NW 54th St, Miami, FL 33127",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1-hiS50ZCrpLPWXbYvKYv5tJyxeyogbo&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Sacramento",
      "Phone": "916-461-7672",
      "Address": [
        {
          "Location1": "Sacramento",
          "Address1": "2015 J St, Sacramento, CA 95811",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1f4Ra1abEjnnszAfIdOD2KJJTEde07R0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Santa Monica",
      "Phone": "310-742-9051",
      "Address": [
        {
          "Location1": "Santa Monica",
          "Address1": "2917 Santa Monica Blvd, Santa Monica, CA 90404",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1f4Ra1abEjnnszAfIdOD2KJJTEde07R0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Valley",
      "Phone": "747-302-6801",
      "Address": [
        {
          "Location1": "Valley",
          "Address1": "17525 Ventura Blvd, Encino, CA 91316",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1f4Ra1abEjnnszAfIdOD2KJJTEde07R0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Oxnard",
      "Phone": "805-866-4776",
      "Address": [
        {
          "Location1": "Oxnard",
          "Address1": "705 N Oxnard Blvd, Oxnard, CA 93030",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1f4Ra1abEjnnszAfIdOD2KJJTEde07R0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Riverside",
      "Phone": "951-904-3274",
      "Address": [
        {
          "Location1": "Riverside",
          "Address1": "3838 Sherman Dr, Riverside, CA 92503",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1f4Ra1abEjnnszAfIdOD2KJJTEde07R0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Boston",
      "Phone": "857-688-9239",
      "Address": [
        {
          "Location1": "Boston",
          "Address1": "295 Huntington Ave, Boston, MA 02115",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1yho9ZClpYYs5-XVsvPoakgClI1cGW00&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Providence",
      "Phone": "401-240-1187",
      "Address": [
        {
          "Location1": "Providence",
          "Address1": "1590 S County Trl, East Greenwich, RI 02818",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=19sCpvNHfs2nsnb7gXqYazMcVaDPtlMg&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Cleveland",
      "Phone": "216-480-5198",
      "Address": [
        {
          "Location1": "Cleveland",
          "Address1": "5302 Memphis Ave, Cleveland, OH 44109",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1yNBBqJvjaTYSULO-rnfEyRDfpLDl8_k&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Diego",
      "Phone": "619-436-4465",
      "Address": [
        {
          "Location1": "San Diego",
          "Address1": "7480 Miramar Rd, San Diego, CA 92126",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1t041CxbPzWmdnVenmhzZGIwlfxETi7E&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Knoxville",
      "Phone": "865-935-5509",
      "Address": [
        {
          "Location1": "Knoxville",
          "Address1": "192 N Seven Oaks Dr, Knoxville, TN 37922",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=18WO5IaIoTUxbT94-cyxay_cSjU7MG0I&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Phoenix",
      "Phone": "602-638-2975",
      "Address": [
        {
          "Location1": "Phoenix",
          "Address1": "9838 N 19th Ave, Phoenix, AZ 85021",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1Msxuhd3bUNheRJDX7TytN94Bb4yvMdE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Columbus",
      "Phone": "614-698-1090",
      "Address": [
        {
          "Location1": "Columbus",
          "Address1": "83 S 4th St, Columbus, OH 43215",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1KeRefWQyo4xvm94KiIaEAD-I1Tv-ipU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New Orleans",
      "Phone": "504-318-3069",
      "Address": [
        {
          "Location1": "New Orleans",
          "Address1": "2728 Decatur St, Kenner, LA 70062",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1rsEp_U1z2D1tFONzYAHz4kUdWNvRNSw&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Charleston",
      "Phone": "843-948-2654",
      "Address": [
        {
          "Location1": "Charleston",
          "Address1": "4 Carriage Ln, Charleston, SC 29407",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1hw2L4CiXManJ_CI58HuHZ19PfTcRZQ8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Milwaukee",
      "Phone": "414-261-5390",
      "Address": [
        {
          "Location1": "Milwaukee",
          "Address1": "11911 W Silver Spring Rd, Milwaukee, WI 53225",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1UhLnu-LJ2ZJs75rlYEslvH_k0rwDywQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Raleigh",
      "Phone": "919-823-3876",
      "Address": [
        {
          "Location1": "Raleigh",
          "Address1": "1700 Glenwood Ave, Raleigh, NC 27608",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1mU80sHsrx3sajxGM2kUjBAflBUJSYbU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Birmingham",
      "Phone": "205-728-1735",
      "Address": [
        {
          "Location1": "Birmingham",
          "Address1": "924 Montclair Rd, Birmingham, AL 35213",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1QR-lb-vzRwo6JqsxoALu0-j4RXq8Hcw&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Norfolk",
      "Phone": "757-347-8139",
      "Address": [
        {
          "Location1": "Norfolk",
          "Address1": "192 Ballard Ct, Virginia Beach, VA 23462",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1QR-lb-vzRwo6JqsxoALu0-j4RXq8Hcw&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Cincinnati",
      "Phone": "513-327-5421",
      "Address": [
        {
          "Location1": "Cincinnati",
          "Address1": "2300 Montana Ave, Cincinnati, OH 45211",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1007Wevk9UO7H_NF5el9BicLFmUCr-Ms&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Monsey",
      "Phone": "845-327-1674",
      "Address": [
        {
          "Location1": "Monsey",
          "Address1": "5 Paragon Dr, Montvale, NJ 07645",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1ruNj0ARlxKW5nXKHT2J5OGeA8b-03pU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Portland",
      "Phone": "503-563-7198",
      "Address": [
        {
          "Location1": "Portland",
          "Address1": "10005 SE Stark St, Portland, OR 97216",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1rNiB_ySheM5dd5ID9EUfOFilUjFg0UQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "West Palm Beach",
      "Phone": "561-861-1005",
      "Address": [
        {
          "Location1": "West Palm Beach",
          "Address1": "2800 S Dixie Hwy, West Palm Beach, FL 33405",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1NJytl2FwaGzC4bZ4vu2TbXZrkrMj4GA&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Oklahoma City",
      "Phone": "405-914-6214",
      "Address": [
        {
          "Location1": "Oklahoma City",
          "Address1": "3033 NW 63rd St, Oklahoma City, OK 73116",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1fUVMVNlHc47pYNN1YR46BQkF23pryl0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Indianapolis",
      "Phone": "317-951-9480",
      "Address": [
        {
          "Location1": "Indianapolis",
          "Address1": "4201 Millersville Rd, Indianapolis, IN 46205",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1BxTUns9WQX4vztBWS0UhLcOlK7kBHJU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Louisville",
      "Phone": "502-706-7052",
      "Address": [
        {
          "Location1": "Louisville",
          "Address1": "1169 Eastern Pkwy, Louisville, KY 40217",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1ifIMqzL5jRSg4NBMY_bdONq36UDzm_Q&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Salt Lake City",
      "Phone": "801-214-1198",
      "Address": [
        {
          "Location1": "Salt Lake City",
          "Address1": "650 S Main St, Salt Lake City, UT 84101",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1R-XIKyV0rDl14--MUC00lCdUgK-Nr48&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Las Vegas",
      "Phone": "702-919-5469",
      "Address": [
        {
          "Location1": "Las Vegas",
          "Address1": "3010 W Charleston Blvd, Las Vegas, NV 89102",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1t-jtHfJK5Pq0xkWOB0jNOUptMN3kb9Y&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Pensacola",
      "Phone": "850-719-7143",
      "Address": [
        {
          "Location1": "Pensacola",
          "Address1": "5151 N 9th Ave, Pensacola, FL 32504",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1aDnrWu--AvpT-KgjgOFvDld9uf0bWOo&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Columbia SC",
      "Phone": "803-618-0915",
      "Address": [
        {
          "Location1": "Columbia SC",
          "Address1": "301 Greystone Blvd, Columbia, SC 29210",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1FLOLJRWgTSK4Al9racgtAgroV1Al0ho&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Greenville",
      "Phone": "864-651-4185",
      "Address": [
        {
          "Location1": "Greenville",
          "Address1": "477 Haywood Rd, Greenville, SC 29607",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=14Bfv3ruWHSMU-yNNygyhlY0NlPf67bE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Albuquerque",
      "Phone": "505-278-7461",
      "Address": [
        {
          "Location1": "Albuquerque",
          "Address1": "400 Gold Ave SW, Albuquerque, NM 87102",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1QPWWvAkdgh-wHkZSG4cC8aTjdbhP3J4&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Chattanooga",
      "Phone": "423-820-1375",
      "Address": [
        {
          "Location1": "Chattanooga",
          "Address1": "2226 Encompass Dr, Chattanooga, TN 37421",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1S1zsAvFNLN37TC8Ih0IstKmAfAxYN4M&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Tuscon",
      "Phone": "520-614-7163",
      "Address": [
        {
          "Location1": "Tuscon",
          "Address1": "4775 S Butterfield Dr, Tucson, AZ 85714",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1-Qija8eglCmUNxUDpZux8pj-bH3GQiQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Antonio",
      "Phone": "210-693-0254",
      "Address": [
        {
          "Location1": "San Antonio",
          "Address1": "515 San Pedro Ave, San Antonio, TX 78212",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1AuqzHiOAZMwFHM7GVKNbvpXsot3LKoQ&ehbc=2E312F&noprof=1",
    },
  ]
  const locationsMainAirDuct = [
    {
      "Location": "Austin",
      "Phone": "737-299-0749",
      "Address": [
        {
          "Location1": "Austin",
          "Address1": "500 E Saint Johns Ave, Austin, TX 78752",
        },
        {
          "Location1": "San Antonio",
          "Address1": "10609 W IH 10, San Antonio, TX 78230",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1ZFzBzklHnjRzKFG32H-Wn9TxmmpdSu8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Chicago",
      "Phone": "872-278-2324",
      "Address": [
        {
          "Location1": "Chicago",
          "Address1": "3257 N Sheffield Ave, Chicago, IL 60657",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1Y2d_hgj3Z2rnaUFE90sd_RmsM456iVI&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Connecticut",
      "Phone": "475-260-7866",
      "Address": [
        {
          "Location1": "Hartford",
          "Address1": "1500 Albany Ave, Hartford, CT 06112",
        },
        {
          "Location1": "Hamden",
          "Address1": "2321 Whitney Ave, Hamden, CT 06518",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1arTs8xd0v35vvinYSHJY5y2cU9EPi7g&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Houston",
      "Phone": "346-522-4902",
      "Address": [
        {
          "Location1": "Houston",
          "Address1": "1808 Antoine Dr, Houston, TX 77055",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1KYM_Tnx3zFBA9vvUnimOYgc3YHLlLBE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Kansas",
      "Phone": "913-361-5843",
      "Address": [
        {
          "Location1": "Kansas",
          "Address1": "455 Nichols Rd, Kansas City, MO 64112",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1cyZUyG54v6vYltik3L6Zbfpd7Cm6gW0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Los Angeles",
      "Phone": "213-561-3642",
      "Address": [
        {
          "Location1": "Valley",
          "Address1": "16311 Ventura Blvd, Encino, CA 91436",
        },
        {
          "Location1": "Los Angeles",
          "Address1": "751 E Olympic Blvd, Los Angeles, CA 90023",
        },
        {
          "Location1": "Riverside",
          "Address1": "3838 Sherman Dr, Riverside, CA 92503",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1igOR7boZkzmdyNwUcncKxxA65IggcHE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Minneapolis",
      "Phone": "651-401-4697",
      "Address": [
        {
          "Location1": "Minneapolis",
          "Address1": "1313 W 26th St, Minneapolis, MN 55405",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=12fYx_1i1hARDMU9SIht0RVfutlIhFfM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New Jersey",
      "Phone": "732-427-8286",
      "Address": [
        {
          "Location1": "Moorestown",
          "Address1": "214 W Main St, Moorestown, NJ 08057",
        },
        {
          "Location1": "Newark",
          "Address1": "831 Broadway, Newark, NJ 07104",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1wCzvOW3l5LHsYiJ8weh2xoTKcaS8nb8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Orlando",
      "Phone": "407-759-5397",
      "Address": [
        {
          "Location1": "Orlando",
          "Address1": "1277 N Semoran Blvd, Orlando, FL 32807",
        },
        {
          "Location1": "Jacksonville",
          "Address1": "1028 Park St, Jacksonville, FL 32204",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1NjUXcA6OX2tJZ-Xht56H0wZZNLiGbeQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Seattle",
      "Phone": "206-565-1416",
      "Address": [
        {
          "Location1": "Seattle",
          "Address1": "425 Pontius Ave N, Seattle, WA 98109",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1wpt9MtPAqDTtBJ8BGNjpjdKnSZ4IYxA&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Saint Louis",
      "Phone": "314-582-9677",
      "Address": [
        {
          "Location1": "Saint Louis",
          "Address1": "12 Maryland, Saint Louis, MO 63108",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=15wIgRS6l1GFxtX5Ongf6ArLwOsAcML0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Tampa",
      "Phone": "813-609-0027",
      "Address": [
        {
          "Location1": "Tampa",
          "Address1": "4115 W Spruce St, Tampa, FL 33607",
        },
        {
          "Location1": "Fort Myers",
          "Address1": "1815 Hough St, Fort Myers, FL 33901",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1sLBr2KXbf8fs1MWdeT9eGkrQDZ-gqXk&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Denver",
      "Phone": "720-358-8602",
      "Address": [
        {
          "Location1": "Denver",
          "Address1": "1415 Park Ave W, Denver, CO 80205",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1-dZYn4IqFRsZTQoHlvmE7CAay5fosYQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Charlotte",
      "Phone": "704-396-4833",
      "Address": [
        {
          "Location1": "Charlotte",
          "Address1": "1500 E 4th, Charlotte, NC 28204",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1mhFU5wqgrPgYF_kqrRbwxfZT9SGr_BI&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Nashville",
      "Phone": "615-257-3414",
      "Address": [
        {
          "Location1": "Nashville",
          "Address1": "2509 Winford Ave, Nashville, TN 37211",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1b1273439kLELw9wSSiqD-_WhlAKGl18&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Dallas",
      "Phone": "214-677-4948",
      "Address": [
        {
          "Location1": "Dallas",
          "Address1": "1346 Motor Cir, Dallas, TX 75207",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1Jq7olr9nIOOlBvrge9gBtQZ1gv38eSk&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Atlanta",
      "Phone": "678-671-5732",
      "Address": [
        {
          "Location1": "Atlanta",
          "Address1": "437 Memorial Dr, Atlanta, GA 30312",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1sIJWXQRLTPmw4YVHmgahsrJWSgd1VEM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Fransisco",
      "Phone": "415-874-1477",
      "Address": [
        {
          "Location1": "San Fransisco",
          "Address1": "2940 16th St, San Francisco, CA 94103",
        },
        {
          "Location1": "Walnut Creek",
          "Address1": "1330 N Broadway, Walnut Creek, CA 94596",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1P2j6c4nBHDRM-AtgEDKq0HXXFq0TcIM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Jose",
      "Phone": "408-351-0593",
      "Address": [
        {
          "Location1": "San Jose",
          "Address1": "770 W Hamilton Ave, Campbell, CA 95008",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1VTJ5eC5cJ1lvDHm3-xJ-8DaTl412cv8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Detroit",
      "Phone": "313-349-2251",
      "Address": [
        {
          "Location1": "Detroit",
          "Address1": "10545 Joy Rd, Detroit, MI 48204",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1EbsUpXTpW8B457T-xz2aBMfyTDb7EYs&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New York",
      "Phone": "516-973-3231",
      "Address": [
        {
          "Location1": "New York",
          "Address1": "51 Bell Blvd, Bayside, NY 11361",
        },
        {
          "Location1": "Farmingdale",
          "Address1": "1111 Broadhollow Rd, Farmingdale, NY 11735",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=17OjSFSNGhqK3w-aOCSkHNgDzV8ybfjc&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Ohio",
      "Phone": "330-993-4070",
      "Address": [
        {
          "Location1": "Fort Wayne",
          "Address1": "10260 Maysville Rd, Fort Wayne, IN 46835",
        },
        {
          "Location1": "Toledo",
          "Address1": "619 Monroe St, Toledo, OH 43604",
        },
        {
          "Location1": "Dayton",
          "Address1": "1024 S Smithville Rd, Dayton, OH 45403",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1T_-ChddVtp0sNncfKQ1_eqiV2h6tCxc&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Philadelphia",
      "Phone": "215-599-2613",
      "Address": [
        {
          "Location1": "Philadelphia",
          "Address1": "25 N American St, Philadelphia, PA 19133",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1D8wzDRrVB_qzrwo_8RkQA30RgZu0Q2I&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Maryland",
      "Phone": "443-381-0813",
      "Address": [
        {
          "Location1": "Wheaton",
          "Address1": "11123 Veirs Mill Rd, Wheaton, MD 20902",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1hFBKavqDPHMd0GUtJ-dU5YcIwaZPHZg&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Miami",
      "Phone": "786-982-8681",
      "Address": [
        {
          "Location1": "Miami",
          "Address1": "310 NW 54th St, Miami, FL 33127",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1-hiS50ZCrpLPWXbYvKYv5tJyxeyogbo&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Sacramento",
      "Phone": "916-249-2232",
      "Address": [
        {
          "Location1": "Sacramento",
          "Address1": "2015 J St, Sacramento, CA 95811",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1f4Ra1abEjnnszAfIdOD2KJJTEde07R0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Santa Monica",
      "Phone": "310-878-0042",
      "Address": [
        {
          "Location1": "Santa Monica",
          "Address1": "2917 Santa Monica Blvd, Santa Monica, CA 90404",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1f4Ra1abEjnnszAfIdOD2KJJTEde07R0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Valley",
      "Phone": "747-297-8883",
      "Address": [
        {
          "Location1": "Valley",
          "Address1": "17525 Ventura Blvd, Encino, CA 91316",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1f4Ra1abEjnnszAfIdOD2KJJTEde07R0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Oxnard",
      "Phone": "805-873-8674",
      "Address": [
        {
          "Location1": "Oxnard",
          "Address1": "705 N Oxnard Blvd, Oxnard, CA 93030",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1f4Ra1abEjnnszAfIdOD2KJJTEde07R0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Riverside",
      "Phone": "951-577-2291",
      "Address": [
        {
          "Location1": "Riverside",
          "Address1": "3838 Sherman Dr, Riverside, CA 92503",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1f4Ra1abEjnnszAfIdOD2KJJTEde07R0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Boston",
      "Phone": "857-598-8822",
      "Address": [
        {
          "Location1": "Boston",
          "Address1": "295 Huntington Ave, Boston, MA 02115",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1yho9ZClpYYs5-XVsvPoakgClI1cGW00&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Providence",
      "Phone": "401-372-8367",
      "Address": [
        {
          "Location1": "Providence",
          "Address1": "1590 S County Trl, East Greenwich, RI 02818",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=19sCpvNHfs2nsnb7gXqYazMcVaDPtlMg&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Cleveland",
      "Phone": "216-777-4228",
      "Address": [
        {
          "Location1": "Cleveland",
          "Address1": "5302 Memphis Ave, Cleveland, OH 44109",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1yNBBqJvjaTYSULO-rnfEyRDfpLDl8_k&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Diego",
      "Phone": "619-983-0923",
      "Address": [
        {
          "Location1": "San Diego",
          "Address1": "7480 Miramar Rd, San Diego, CA 92126",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1t041CxbPzWmdnVenmhzZGIwlfxETi7E&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Knoxville",
      "Phone": "865-345-5963",
      "Address": [
        {
          "Location1": "Knoxville",
          "Address1": "192 N Seven Oaks Dr, Knoxville, TN 37922",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=18WO5IaIoTUxbT94-cyxay_cSjU7MG0I&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Phoenix",
      "Phone": "602-497-4349",
      "Address": [
        {
          "Location1": "Phoenix",
          "Address1": "9838 N 19th Ave, Phoenix, AZ 85021",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1Msxuhd3bUNheRJDX7TytN94Bb4yvMdE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Columbus",
      "Phone": "614-858-3932",
      "Address": [
        {
          "Location1": "Columbus",
          "Address1": "83 S 4th St, Columbus, OH 43215",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1KeRefWQyo4xvm94KiIaEAD-I1Tv-ipU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New Orleans",
      "Phone": "504-285-7513",
      "Address": [
        {
          "Location1": "New Orleans",
          "Address1": "2728 Decatur St, Kenner, LA 70062",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1rsEp_U1z2D1tFONzYAHz4kUdWNvRNSw&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Charleston",
      "Phone": "843-396-3342",
      "Address": [
        {
          "Location1": "Charleston",
          "Address1": "4 Carriage Ln, Charleston, SC 29407",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1hw2L4CiXManJ_CI58HuHZ19PfTcRZQ8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Milwaukee",
      "Phone": "414-348-5791",
      "Address": [
        {
          "Location1": "Milwaukee",
          "Address1": "11911 W Silver Spring Rd, Milwaukee, WI 53225",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1UhLnu-LJ2ZJs75rlYEslvH_k0rwDywQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Raleigh",
      "Phone": "919-820-8274",
      "Address": [
        {
          "Location1": "Raleigh",
          "Address1": "1700 Glenwood Ave, Raleigh, NC 27608",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1mU80sHsrx3sajxGM2kUjBAflBUJSYbU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Birmingham",
      "Phone": "205-236-3968",
      "Address": [
        {
          "Location1": "Birmingham",
          "Address1": "924 Montclair Rd, Birmingham, AL 35213",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1QR-lb-vzRwo6JqsxoALu0-j4RXq8Hcw&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Norfolk",
      "Phone": "757-909-7945",
      "Address": [
        {
          "Location1": "Norfolk",
          "Address1": "192 Ballard Ct, Virginia Beach, VA 23462",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1QR-lb-vzRwo6JqsxoALu0-j4RXq8Hcw&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Cincinnati",
      "Phone": "513-877-6034",
      "Address": [
        {
          "Location1": "Cincinnati",
          "Address1": "2300 Montana Ave, Cincinnati, OH 45211",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1007Wevk9UO7H_NF5el9BicLFmUCr-Ms&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Monsey",
      "Phone": "845-622-6847",
      "Address": [
        {
          "Location1": "Monsey",
          "Address1": "5 Paragon Dr, Montvale, NJ 07645",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1ruNj0ARlxKW5nXKHT2J5OGeA8b-03pU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Portland",
      "Phone": "503-433-8918",
      "Address": [
        {
          "Location1": "Portland",
          "Address1": "10005 SE Stark St, Portland, OR 97216",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1rNiB_ySheM5dd5ID9EUfOFilUjFg0UQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "West Palm Beach",
      "Phone": "561-406-0775",
      "Address": [
        {
          "Location1": "West Palm Beach",
          "Address1": "2800 S Dixie Hwy, West Palm Beach, FL 33405",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1NJytl2FwaGzC4bZ4vu2TbXZrkrMj4GA&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Oklahoma City",
      "Phone": "405-817-5722",
      "Address": [
        {
          "Location1": "Oklahoma City",
          "Address1": "3033 NW 63rd St, Oklahoma City, OK 73116",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1fUVMVNlHc47pYNN1YR46BQkF23pryl0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Indianapolis",
      "Phone": "317-659-6435",
      "Address": [
        {
          "Location1": "Indianapolis",
          "Address1": "4201 Millersville Rd, Indianapolis, IN 46205",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1BxTUns9WQX4vztBWS0UhLcOlK7kBHJU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Louisville",
      "Phone": "502-521-1472",
      "Address": [
        {
          "Location1": "Louisville",
          "Address1": "1169 Eastern Pkwy, Louisville, KY 40217",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1ifIMqzL5jRSg4NBMY_bdONq36UDzm_Q&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Salt Lake City",
      "Phone": "801-981-9481",
      "Address": [
        {
          "Location1": "Salt Lake City",
          "Address1": "650 S Main St, Salt Lake City, UT 84101",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1R-XIKyV0rDl14--MUC00lCdUgK-Nr48&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Las Vegas",
      "Phone": "702-935-6585",
      "Address": [
        {
          "Location1": "Las Vegas",
          "Address1": "3010 W Charleston Blvd, Las Vegas, NV 89102",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1t-jtHfJK5Pq0xkWOB0jNOUptMN3kb9Y&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Pensacola",
      "Phone": "850-821-7297",
      "Address": [
        {
          "Location1": "Pensacola",
          "Address1": "5151 N 9th Ave, Pensacola, FL 32504",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1aDnrWu--AvpT-KgjgOFvDld9uf0bWOo&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Columbia SC",
      "Phone": "803-618-0863",
      "Address": [
        {
          "Location1": "Columbia SC",
          "Address1": "301 Greystone Blvd, Columbia, SC 29210",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1FLOLJRWgTSK4Al9racgtAgroV1Al0ho&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Greenville",
      "Phone": "864-528-3916",
      "Address": [
        {
          "Location1": "Greenville",
          "Address1": "477 Haywood Rd, Greenville, SC 29607",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=14Bfv3ruWHSMU-yNNygyhlY0NlPf67bE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Albuquerque",
      "Phone": "505-535-4397",
      "Address": [
        {
          "Location1": "Albuquerque",
          "Address1": "400 Gold Ave SW, Albuquerque, NM 87102",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1QPWWvAkdgh-wHkZSG4cC8aTjdbhP3J4&ehbc=2E312F&noprof=1",
    },
        {
      "Location": "Chattanooga",
      "Phone": "423-799-3174",
      "Address": [
        {
          "Location1": "Chattanooga",
          "Address1": "2226 Encompass Dr, Chattanooga, TN 37421",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1S1zsAvFNLN37TC8Ih0IstKmAfAxYN4M&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Tuscon",
      "Phone": "520-518-3636",
      "Address": [
        {
          "Location1": "Tuscon",
          "Address1": "4775 S Butterfield Dr, Tucson, AZ 85714",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1-Qija8eglCmUNxUDpZux8pj-bH3GQiQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Antonio",
      "Phone": "210-934-7654",
      "Address": [
        {
          "Location1": "San Antonio",
          "Address1": "515 San Pedro Ave, San Antonio, TX 78212",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1AuqzHiOAZMwFHM7GVKNbvpXsot3LKoQ&ehbc=2E312F&noprof=1",
    },
  ]
  // Blog
  const [Blogs, setBlogs] = useState([
    {
      Title: "Comprehensive Guide to Chimney Inspection: How BHO Chimney Sweepn Assist You",
      BlogPath: "Comprehensive Guide to Chimney Inspection: How BHO Chimney Sweepn Assist You",
      tegoryPath: "chimney-inspection",
      category: "Chimney Inspection",
      Date: "May 24, 2023",
      Discription: "Chimneys are a vital part of many homes, especially for those who enjoy the warmth and ambiance of a cozy fireplace during the cooler months. However, maintaining a chimney is more than just an occasional cleaning—it requires regular inspections to ensure safety and functionality. A well-maintained chimney not only protects your home from fire hazards but also ensures that your fireplace operates efficiently. This comprehensive guide will explore the importance of chimney inspections, the process involved, and how BHO Chimney Sweepn help you maintain a safe and efficient chimney.",
      Photos: Chimney4,
      BlogId: 1,
      BlogPathMenu: ["Chimney inspection", "Chimney safety BHO", "Professional chimney inspection", "Creosote removal BHO", "Chimney maintenance service", "Fireplace inspection BHO", "Chimney repair", "Chimney cleaning BHO", "Chimney inspection experts", "BHO Chimney Sweep services"],
      Text: `
<div class="markdown prose w-full break-words dark:prose-invert light"><h3>Comprehensive Guide to Chimney Inspection: How BHO Chimney Sweepn Assist You</h3><p>Chimneys are a vital part of many homes, especially for those who enjoy the warmth and ambiance of a cozy fireplace during the cooler months. However, maintaining a chimney is more than just an occasional cleaning—it requires regular inspections to ensure safety and functionality. A well-maintained chimney not only protects your home from fire hazards but also ensures that your fireplace operates efficiently. This comprehensive guide will explore the importance of chimney inspections, the process involved, and how BHO Chimney Sweepn help you maintain a safe and efficient chimney.</p><h4>The Importance of Chimney Inspections</h4><p><strong>1. Identifying Hidden Hazards</strong></p><p>One of the most significant reasons for regular <a href="/service/Chimney-Inspection">chimney inspections</a> is to identify hidden hazards that could pose serious risks to your home and family. Over time, chimneysn develop cracks, blockages, and other structural issues that may not be visible to the naked eye. These problemsn lead to dangerous situations, such as chimney fires orrbon monoxide leaks, if not addressed promptly. A professional inspectionn uncover these hidden dangers before they becometastrophic.</p><p><strong>2. Ensuring Proper Ventilation</strong></p><p>Proper ventilation is critical for the safe operation of your fireplace or stove. A chimney that is blocked or damagedn impede the flow of smoke and harmful gases, likerbon monoxide, out of your home. Thisn lead to a buildup of these gases inside your home, posing significant health risks. Regular inspections ensure that your chimney is clear of obstructions and functioning as it should, allowing for safe and efficient ventilation.</p><p><strong>3. Preventing Chimney Fires</strong></p><p>Chimney fires are a significant risk for homes that use fireplaces regularly. Creosote, a byproduct of burning wood,n accumulate inside the chimney over time. This highly flammable substancen ignite if not regularly removed, leading to dangerous chimney fires. During an inspection, technicians will assess the level of creosote buildup and recommend necessary <a href="/service/Chimney-Cleaning">chimney cleaning</a> or <a href="/service/Creosote-Removal">creosote removal</a> services to mitigate this risk.</p><p><strong>4. Extending the Life of Your Chimney</strong></p><p>Routine <a href="/service/Chimney-Maintenance">chimney maintenance</a> and inspections help to extend the lifespan of your chimney. By identifying and addressing issues early, youn prevent them from escalating into major problems that require costly repairs or even a complete chimney rebuild. Regular inspections help keep your chimney in optimal condition, ensuring it serves your home safely and efficiently for years to come.</p><p><strong>5. Compliance with Local Codes and Insurance Requirements</strong></p><p>In many areas, including BHO, local building codes and insurance policies may require regular chimney inspections. Failing to adhere to these requirementsn result in fines or voided insurance coverage in the event of a chimney-related incident. Regular inspections not only ensure compliance with local regulations but also provide peace of mind knowing your home is protected.</p><h4>The Chimney Inspection Process</h4><p>Understanding the chimney inspection processn help you appreciate the importance of professional chimney services and what to expect when you hire BHO Chimney Sweep.</p><p><strong>1. Initial Assessment</strong></p><p>The first step in the inspection process is an initial assessment, where the technician will visually inspect the exterior and interior of your chimney. This includes checking for visible cracks, damage, or signs of wear and tear on the chimney structure. The technician will also look for any blockages or obstructions that could impede proper ventilation.</p><p><strong>2. Interior Examination</strong></p><p>After the initial assessment, the technician will conduct a more in-depth examination of the chimney's interior. This may involve the use of specializedmeras or other tools to inspect the flue, liner, and other internal components. The goal is to identify any hidden issues, such as cracks, creosote buildup, or blockages, that could pose a risk to your home.</p><p><strong>3. Creosote Buildup Evaluation</strong></p><p>One of the critical components of a chimney inspection is evaluating the level of creosote buildup inside the chimney. Creosote is a byproduct of burning wood that accumulates over time andn become highly flammable if not regularly removed. The technician will assess the creosote levels and recommend a <a href="/service/Creosote-Removal">creosote removal</a> or <a href="/service/Chimney-Cleaning">chimney cleaning</a> service if necessary.</p><p><strong>4. Structural Integrity Check</strong></p><p>The structural integrity of your chimney is crucial for its safe operation. During the inspection, the technician will check the condition of the chimney liner, masonry, and other structural components. This includes looking for signs of deterioration, such as cracks in the liner or crumbling mortar. If any issues are found, the technician will recommend necessary <a href="/service/Chimney-Repair">repairs</a> to ensure the chimney remains safe and functional.</p><p><strong>5. Draft Test</strong></p><p>Proper draft is essential for the efficient operation of your fireplace. A draft test may be conducted during the inspection to ensure that the chimney is drawing air correctly. Poor draftn result in smoke entering your home rather than being vented outside, leading to unpleasant odors and potential health risks. If a draft issue is detected, the technician may recommend adjustments or additional <a href="/service/Chimney-Draft-Issues">services</a> to improve airflow.</p><p><strong>6. Final Report and Recommendations</strong></p><p>After completing the inspection, the technician will provide you with a detailed report outlining their findings. This report will include any issues discovered during the inspection, along with recommendations for necessary <a href="/service/Chimney-Repair">repairs</a> or <a href="/service/Chimney-Maintenance">maintenance</a> to keep your chimney in optimal condition. The report will also include an estimate for any recommended services.</p><h4>How BHO Chimney Sweepn Help</h4><p>BHO Chimney Sweep is a trusted provider of professional chimney inspection services. With years of experience and a commitment to customer satisfaction, they offer comprehensive chimney that goes beyond basic inspections. Here's how theyn assist you with your chimney needs:</p><p><strong>1. Expertise and Experience</strong></p><p>The team at BHO Chimney Sweep consists of certified and experienced technicians who are well-versed in all aspects of chimney maintenance. Their expertise ensures that your chimney is thoroughly inspected, and any potential issues are identified and addressed promptly. Whether you need a routine inspection or suspect a problem with your chimney, BHO Chimney Sweep has the knowledge and skills to provide the necessary services.</p><p><strong>2. Customized Service</strong></p><p>BHO Chimney Sweep understands that every home and chimney is unique. They offer customized inspection services tailored to your specific needs, whether you have a traditional wood-burning fireplace, a gas stove, or a more modern heating system. Their technicians take the time to understand your chimney's history and current condition, providing a personalized approach to ensure the best possiblere.</p><p><strong>3. Advanced Equipment</strong></p><p>Utilizing the latest tools and technology, BHO Chimney Sweep ensures a thorough and efficient inspection process. Their advanced equipment allows them to reach every part of your chimney, ensuring no hidden issues are left undiscovered. This includes specializedmeras for inspecting the flue and liner, as well as tools for assessing creosote buildup and blockages.</p><p><strong>4. Comprehensive Services</strong></p><p>In addition to inspections, BHO Chimney Sweep offers a wide range of related services to keep your chimney in top condition. These include <a href="/service/Chimney-Cleaning">chimney cleaning</a>, <a href="/service/Chimney-Repair">chimney repair</a>, <a href="/service/Chimney-Liner-Installation">chimney liner installation</a>, and <a href="/service/Chimney-Cap-Installation">chimneyp installation</a>. Their goal is to provide comprehensivere for your chimney, ensuring it remains safe and functional for years to come.</p><p><strong>5. Affordable Pricing</strong></p><p>BHO Chimney Sweep is committed to providing top-quality service at competitive prices. They offer transparent pricing with no hidden fees, ensuring you know exactly what you're paying for. Whether you need a basic inspection or more extensive repairs, they work with you to find a solution that fits your budget.</p><p><strong>6. Convenient Scheduling</strong></p><p>Understanding that your time is valuable, BHO Chimney Sweep offers flexible scheduling options to fit your busy lifestyle. Youn easily book an appointment online through their <a href="/book">online scheduling page</a>, or younll them directly at <a href='866-501-1614'>866-501-1614</a> to speak with a representative. Their team is ready to assist you with any questions or concerns you might have.</p><p><strong>7. Satisfaction Guarantee</strong></p><p>BHO Chimney Sweep stands behind their work with a satisfaction guarantee, ensuring that you are completely happy with the service provided. They take pride in their reputation for reliability and customer service, making them the go-to choice for chimney inspections in BHO.</p><h4>Why Choose BHO Chimney Sweep?</h4><p>Choosing BHO Chimney Sweep for your chimney inspection needs means partnering with a company that values safety, quality, and customer service. Here are a few reasons why they stand out:</p><p><strong>Local Expertise</strong>: As a local business, BHO Chimney Sweep understands the unique needs of homeowners. They are familiar with local building codes, weather patterns, and common chimney issues in the area.</p><p><strong>Trustworthy Service</strong>: BHO Chimney Sweep has built a reputation for reliability and integrity. Their commitment to excellence ensures that your chimney is thoroughly inspected, and any necessary repairs are performed to the highest standards.</p><p><strong>Comprehensivere</strong>: From initial inspection to final repairs, BHO Chimney Sweep provides comprehensivere for your chimney. They offer a full range of services to address any issue that may arise, ensuring your chimney remains safe and efficient.</p><p><strong>Customer-Focused Approach</strong>: BHO Chimney Sweep puts their customers first, offering personalized service and attention to detail. They take the time to understand your needs and provide solutions that work for you.</p><h4>Conclusion</h4><p>Regular chimney inspections are essential for maintaining the safety, efficiency, and longevity of your chimney, especially. By preventing chimney fires, improving air quality, enhancing heating efficiency, and prolonging the life of your chimney, this routine maintenance task is invaluable. BHO Chimney Sweep is here to help with expert services that ensure your chimney is clean, safe, and ready to use. Whether you need a routine inspection or a comprehensive repair, youn trust BHO Chimney Sweep to provide the quality service your home deserves. Contact them today to schedule your chimney inspection and ensure your home remains safe and comfortable year-round.</p><h4>Keywords</h4><ol><li>Chimney inspection</li><li>Chimney safety BHO</li><li>Professional chimney inspection</li><li>Creosote removal BHO</li><li>Chimney maintenance service</li><li>Fireplace inspection BHO</li><li>Chimney repair</li><li>Chimney cleaning BHO</li><li>Chimney inspection experts</li><li>BHO Chimney Sweep services</li></ol></div>
        `
    },
    {
      Title: "Comprehensive Guide to Chimney Repair: How BHO Chimney Sweepn Assist You",
      BlogPath: "Comprehensive Guide to Chimney Repair: How BHO Chimney Sweepn Assist You",
      tegoryPath: "chimney-repair",
      category: "Chimney Repair",
      Date: "Jun 16, 2023",
      Discription: "Chimneys are a crucial part of many homes, especially for those who enjoy the warmth and ambiance of a fireplace during the cooler months. However, like any other part of your home, chimneys are subject to wear and tear over time. Cracks, leaks, and other structural issuesn develop, compromising the safety and efficiency of your chimney. Regular maintenance and timely repairs are essential to ensure your chimney remains in good working condition. In this comprehensive guide, we will explore the importance of chimney repair, common issues that require attention, and how BHO Chimney Sweepn help you maintain a safe and functional chimney.",
      Photos: Chimney1,
      // Photos: blog1,
      BlogId: 2,
      BlogPathMenu: ["Chimney repair", "Chimney maintenance BHO", "Cracked chimney liner repair", "Chimney leak detection BHO", "Chimney crown repair services", "Chimney repointing BHO", "Chimney repair experts BHO", "Professional chimney services", "Chimney structural repair", "BHO Chimney Sweep repair"],
      Text: `
<div class="markdown prose w-full break-words dark:prose-invert light"><h3>Comprehensive Guide to Chimney Repair: How BHO Chimney Sweepn Assist You</h3><p>Chimneys are a crucial part of many homes, especially for those who enjoy the warmth and ambiance of a fireplace during the cooler months. However, like any other part of your home, chimneys are subject to wear and tear over time. Cracks, leaks, and other structural issuesn develop, compromising the safety and efficiency of your chimney. Regular maintenance and timely repairs are essential to ensure your chimney remains in good working condition. In this comprehensive guide, we will explore the importance of chimney repair, common issues that require attention, and how BHO Chimney Sweepn help you maintain a safe and functional chimney.</p><h4>The Importance of Chimney Repair</h4><p><strong>1. Preventing Chimney Fires</strong></p><p>One of the most critical reasons for regular <a href="/service/Chimney-Repair">chimney repairs</a> is to prevent chimney fires. Over time, the structure of your chimneyn deteriorate due to constant exposure to heat, moisture, and the elements. Cracks in the chimney lining or masonryn allow hot gases and embers to escape into the walls of your home, potentiallyusing a fire. Addressing these issues promptly through professional repairsn significantly reduce the risk of chimney fires.</p><p><strong>2. Ensuring Proper Ventilation</strong></p><p>A damaged chimneyn impede the proper ventilation of smoke, gases, and other byproducts of combustion. Thisn lead to dangerous situations where harmful gases, likerbon monoxide, back up into your home instead of being vented outside. Regular repairs ensure that your chimney is free of blockages and that all components are functioning correctly, allowing for safe and efficient ventilation.</p><p><strong>3. Protecting Your Home’s Structure</strong></p><p>The chimney is not only a functional component of your home but also a structural one. Cracks in the chimney’s masonry or linern compromise the stability of the chimney, leading to further damage to your home’s structure. Water infiltration through damaged areasn alsouse significant damage to the chimney and surrounding areas, leading to costly repairs if not addressed promptly.</p><p><strong>4. Improving Energy Efficiency</strong></p><p>A well-maintained chimney contributes to the overall energy efficiency of your home. A chimney that is in disrepairn allow drafts, resulting in heat loss during the winter months. By ensuring that your chimney is properly sealed and in good condition, youn improve the energy efficiency of your home and reduce heating costs.</p><p><strong>5. Enhancing Home Value</strong></p><p>Maintaining your chimney in good repair not only ensures the safety and functionality of your home but also enhances its value. Prospective buyers are more likely to be interested in a home with a well-maintained chimney, as it indicates that the property has beenred for and is less likely to have hidden issues.</p><h4>Common Chimney Repair Issues</h4><p><strong>1. Cracked or Damaged Chimney Liner</strong></p><p>The chimney liner is a crucial component that protects the chimney walls from heat and corrosion. Over time, the linern crack or deteriorate, allowing hot gases and embers to escape into the walls of your home. If your chimney liner is damaged, it’s essential to have it repaired or replaced to ensure the safety of your home. BHO Chimney Sweep offers professional <a href="/service/Chimney-Liner-Installation">chimney liner installation</a> and repair services to keep your chimney in top condition.</p><p><strong>2. Leaking Chimney</strong></p><p>Water infiltration is a common issue thatnuse significant damage to your chimney and home. Leaksn occur due to damaged flashing, cracked chimney crowns, or worn-out mortar joints. If left untreated, waternuse the masonry to deteriorate, leading to structural damage. BHO Chimney Sweep provides comprehensive <a href="/service/Chimney-Leak-Detection">chimney leak detection</a> and repair services to prevent further damage and protect your home.</p><p><strong>3. Crumbling Mortar Joints</strong></p><p>The mortar joints that hold the bricks or stones of your chimney togethern deteriorate over time due to weathering and exposure to the elements. Crumbling mortarn weaken the structural integrity of your chimney, leading to potential collapse if not repaired. Repointing the mortar joints is essential to maintain the strength and stability of your chimney. BHO Chimney Sweep offers expert <a href="/service/Chimney-Repointing">chimney repointing</a> services to restore your chimney’s structural integrity.</p><p><strong>4. Damaged Chimney Crown</strong></p><p>The chimney crown is the topmost part of the chimney that protects it from water infiltration. Over time, the crownn crack or become damaged, allowing water to seep into the chimney anduse deterioration. Repairing or replacing a damaged chimney crown is essential to prevent further water damage and extend the life of your chimney. BHO Chimney Sweep provides professional <a href="/service/Chimney-Crown-Repair">chimney crown repair</a> services to keep your chimney protected.</p><p><strong>5. Blocked or Damaged Flue</strong></p><p>The flue is the passage through which smoke and gases are vented from your home. A blocked or damaged fluen prevent proper ventilation, leading to dangerous situations such asrbon monoxide buildup. If your flue is blocked or damaged, it’s essential to have it repaired or cleaned to ensure safe operation. BHO Chimney Sweep offers thorough <a href="/service/Smoke-Chamber-Repair">flue repair</a> and cleaning services to keep your chimney functioning safely and efficiently.</p><h4>The Chimney Repair Process</h4><p>Understanding the chimney repair processn help you appreciate the importance of professional chimney services and what to expect when you hire BHO Chimney Sweep.</p><p><strong>1. Initial Inspection and Assessment</strong></p><p>The first step in the chimney repair process is a thorough inspection to assess the condition of your chimney. The technician will visually inspect the exterior and interior of the chimney, looking for signs of damage, such as cracks, leaks, or deteriorating mortar. They may also use specialized tools to inspect the flue and liner for blockages or damage.</p><p><strong>2. Repair Plan and Estimate</strong></p><p>After the inspection, the technician will provide you with a detailed repair plan outlining the issues that need to be addressed and the recommended repairs. The plan will include an estimate of the cost and timeline for the repairs, allowing you to make an informed decision.</p><p><strong>3. Repair Execution</strong></p><p>Once you approve the repair plan, the technician will begin the repair process. This may involve replacing damaged bricks or mortar, repairing or replacing the chimney liner, sealing leaks, or addressing any other issues identified during the inspection. The technician will use high-quality materials and advanced techniques to ensure that the repairs are durable and effective.</p><p><strong>4. Final Inspection and Cleanup</strong></p><p>After the repairs are completed, the technician will conduct a final inspection to ensure that all issues have been addressed and that the chimney is in good working condition. They will also clean up the work area, leaving your home as clean as it was before the repairs began.</p><p><strong>5. Maintenance Recommendations</strong></p><p>After the repairs are completed, the technician will provide you with maintenance recommendations to help you keep your chimney in good condition. This may include tips on how to prevent future issues, as well as recommendations for regular <a href="/service/Chimney-Maintenance">chimney maintenance</a> services to ensure that your chimney remains safe and functional.</p><h4>How BHO Chimney Sweepn Help</h4><p>BHO Chimney Sweep is a trusted provider of professional chimney repair services. With years of experience and a commitment to customer satisfaction, they offer comprehensive chimney that goes beyond basic repairs. Here's how theyn assist you with your chimney needs:</p><p><strong>1. Expertise and Experience</strong></p><p>The team at BHO Chimney Sweep consists of certified and experienced technicians who are well-versed in all aspects of chimney maintenance and repair. Their expertise ensures that your chimney is thoroughly inspected, and any potential issues are identified and addressed promptly. Whether you need a minor repair or a complete chimney rebuild, BHO Chimney Sweep has the knowledge and skills to provide the necessary services.</p><p><strong>2. Customized Service</strong></p><p>BHO Chimney Sweep understands that every home and chimney is unique. They offer customized repair services tailored to your specific needs, whether you have a traditional wood-burning fireplace, a gas stove, or a more modern heating system. Their technicians take the time to understand your chimney's history and current condition, providing a personalized approach to ensure the best possiblere.</p><p><strong>3. Advanced Equipment</strong></p><p>Utilizing the latest tools and technology, BHO Chimney Sweep ensures a thorough and efficient repair process. Their advanced equipment allows them to address even the most challenging chimney issues, ensuring no hidden problems are left unresolved. This includes specialized tools for repairing masonry, sealing leaks, and replacing damaged liners.</p><p><strong>4. Comprehensive Services</strong></p><p>In addition to repairs, BHO Chimney Sweep offers a wide range of related services to keep your chimney in top condition. These include <a href="/service/Chimney-Cleaning">chimney cleaning</a>, <a href="/service/Chimney-Inspection">chimney inspection</a>, <a href="/service/Chimney-Liner-Installation">chimney liner installation</a>, and <a href="/service/Chimney-Cap-Installation">chimneyp installation</a>. Their goal is to provide comprehensivere for your chimney, ensuring it remains safe and functional for years to come.</p><p><strong>5. Affordable Pricing</strong></p><p>BHO Chimney Sweep is committed to providing top-quality service at competitive prices. They offer transparent pricing with no hidden fees, ensuring you know exactly what you're paying for. Whether you need a minor repair or a complete chimney rebuild, they work with you to find a solution that fits your budget.</p><p><strong>6. Convenient Scheduling</strong></p><p>Understanding that your time is valuable, BHO Chimney Sweep offers flexible scheduling options to fit your busy lifestyle. Youn easily book an appointment online through their <a href="/book">online scheduling page</a>, or younll them directly at <a href='866-501-1614'>866-501-1614</a> to speak with a representative. Their team is ready to assist you with any questions or concerns you might have.</p><p><strong>7. Satisfaction Guarantee</strong></p><p>BHO Chimney Sweep stands behind their work with a satisfaction guarantee, ensuring that you are completely happy with the service provided. They take pride in their reputation for reliability and customer service, making them the go-to choice for chimney repairs in BHO.</p><h4>Why Choose BHO Chimney Sweep?</h4><p>Choosing BHO Chimney Sweep for your chimney repair needs means partnering with a company that values safety, quality, and customer service. Here are a few reasons why they stand out:</p><p><strong>Local Expertise</strong>: As a local business, BHO Chimney Sweep understands the unique needs of homeowners. They are familiar with local building codes, weather patterns, and common chimney issues in the area.</p><p><strong>Trustworthy Service</strong>: BHO Chimney Sweep has built a reputation for reliability and integrity. Their commitment to excellence ensures that your chimney is thoroughly inspected, and any necessary repairs are performed to the highest standards.</p><p><strong>Comprehensivere</strong>: From initial inspection to final repairs, BHO Chimney Sweep provides comprehensivere for your chimney. They offer a full range of services to address any issue that may arise, ensuring your chimney remains safe and efficient.</p><p><strong>Customer-Focused Approach</strong>: BHO Chimney Sweep puts their customers first, offering personalized service and attention to detail. They take the time to understand your needs and provide solutions that work for you.</p><h4>Conclusion</h4><p>Regular chimney repairs are essential for maintaining the safety, efficiency, and longevity of your chimney, especially. By addressing issues such as cracks, leaks, and deteriorating mortar early, youn prevent more serious damage and costly repairs down the line. BHO Chimney Sweep is here to help with expert services that ensure your chimney is safe, functional, and ready to use. Whether you need a minor repair or a complete chimney rebuild, youn trust BHO Chimney Sweep to provide the quality service your home deserves. Contact them today to schedule your chimney repair and ensure your home remains safe and comfortable year-round.</p><h4>Keywords</h4><ol><li>Chimney repair</li><li>Chimney maintenance BHO</li><li>Cracked chimney liner repair</li><li>Chimney leak detection BHO</li><li>Chimney crown repair services</li><li>Chimney repointing BHO</li><li>Chimney repair experts BHO</li><li>Professional chimney services</li><li>Chimney structural repair</li><li>BHO Chimney Sweep repair</li></ol></div>
        `
    },
    {
      Title: "The Essential Guide to Chimney Cleaning: How BHO Chimney Sweepn Help Keep Your Home Safe",
      BlogPath: "The Essential Guide to Chimney Cleaning: How BHO Chimney Sweepn Help Keep Your Home Safe",
      tegoryPath: "chimney-cleaning",
      category: "Chimney Cleaning",
      Date: "Aug 11, 2024",
      Discription: "Chimney cleaning is an integral part of maintaining a safe and efficient home heating system, particularly, where many homeowners rely on fireplaces during the cooler months. Regular chimney cleaning is not just about keeping your chimney looking good—it’s about protecting your home from potential fire hazards and ensuring that your fireplace operates smoothly. In this comprehensive guide, we will explore the importance of chimney cleaning, the steps involved in the process, and how BHO Chimney Sweepn assist you in maintaining a clean and safe chimney.",
      Photos: Chimney2,
      // Photos: blog1,
      BlogId: 3,
      BlogPathMenu: ["Chimney cleaning", "Professional chimney cleaning", "Creosote removal BHO", "Fireplace cleaning BHO", "Chimney maintenance service", "Chimney sweep BHO", "Chimney safety BHO", "Chimney repair", "Chimney inspection BHO", "BHO Chimney Sweep services"],
      Text: `
<div class="markdown prose w-full break-words dark:prose-invert light"><h3>The Essential Guide to Chimney Cleaning: How BHO Chimney Sweepn Help Keep Your Home Safe</h3><p>Chimney cleaning is an integral part of maintaining a safe and efficient home heating system, particularly, where many homeowners rely on fireplaces during the cooler months. Regular chimney cleaning is not just about keeping your chimney looking good—it’s about protecting your home from potential fire hazards and ensuring that your fireplace operates smoothly. In this comprehensive guide, we will explore the importance of chimney cleaning, the steps involved in the process, and how BHO Chimney Sweepn assist you in maintaining a clean and safe chimney.</p><h4>The Importance of Chimney Cleaning</h4><p><strong>1. Fire Hazard Prevention</strong></p><p>One of the most critical reasons for regular <a href="/service/Chimney-Cleaning">chimney cleaning</a> is to prevent chimney fires. As wood burns in your fireplace, it produces creosote—a sticky, highly flammable substance that coats the inside of your chimney. Over time, this creosoten build up and create a serious fire hazard. If the creosote ignites, itnuse a chimney fire that could easily spread to the rest of your home. Regular chimney cleaning removes this buildup, significantly reducing the risk of such fires.</p><p><strong>2. Improved Air Quality</strong></p><p>A dirty chimneyn have a direct impact on the air quality inside your home. When a chimney is clogged with soot, creosote, or other debris, itn obstruct the proper flow of smoke and gases out of your home. Thisnuse smoke and dangerous gases likerbon monoxide to back up into your living spaces, posing serious health risks. Regular cleaning ensures that your chimney is clear, allowing for the safe and efficient ventilation of harmful byproducts.</p><p><strong>3. Enhanced Fireplace Efficiency</strong></p><p>A clean chimney is essential for the efficient operation of your fireplace. When the chimney is free of blockages and buildup, it allows for better airflow, which in turn enables your fireplace to burn fuel more efficiently. This not only improves the performance of your fireplace but also reduces your heating costs, as your fireplace will require less fuel to produce the same amount of heat.</p><p><strong>4. Prolonged Chimney Life</strong></p><p>Routine <a href="/service/Chimney-Maintenance">chimney maintenance</a>, including regular cleaning, helps to extend the lifespan of your chimney. The buildup of creosote, soot, and other debrisnuse corrosion and damage to the chimney liner and other components. By keeping your chimney clean, you prevent this damage and ensure that your chimney remains in good condition for years to come.</p><p><strong>5. Compliance with Local Regulations</strong></p><p>regular chimney cleaning may be required by local building codes or recommended by your insurance provider. Ensuring that your chimney is regularly cleaned and maintained not only keeps your home safe but also helps you stay compliant with any applicable regulations. Thisn be particularly important if you ever need to file an insurance claim related to chimney or fireplace damage.</p><h4>The Chimney Cleaning Process</h4><p>Understanding the chimney cleaning processn help you appreciate the importance of this essential maintenance task and what to expect when you hire BHO Chimney Sweep.</p><p><strong>1. Pre-Inspection</strong></p><p>Before the cleaning begins, a thorough inspection is conducted to assess the condition of your chimney. This includes checking for creosote buildup, blockages, and any signs of damage. The technician will also look for any potential issues that could affect the cleaning process, such as cracks in the chimney liner or damaged masonry.</p><p><strong>2. Preparation</strong></p><p>To protect your home, the technician will cover the area around your fireplace with tarps or drop cloths. This prevents soot and debris from spreading into your living space during the cleaning process. The technician may also use a specialized vacuum to contain dust and debris as it is removed from the chimney.</p><p><strong>3. Chimney Sweeping</strong></p><p>The actual cleaning process involves using specialized brushes and rods to scrub the interior walls of the chimney. These tools are designed to reach every part of the chimney, ensuring that all creosote, soot, and debris are thoroughly removed. The technician will typically start from the top of the chimney and work their way down to ensure that all loose material isptured and removed.</p><p><strong>4. Blockage Removal</strong></p><p>If the inspection revealed any blockages, such as bird nests, leaves, or other debris, the technician will remove them during the cleaning process. Blockagesn obstruct airflow and increase the risk ofrbon monoxide buildup, so it’s crucial to ensure that the chimney is clear.</p><p><strong>5. Final Inspection</strong></p><p>After the cleaning is complete, a final inspection is conducted to ensure that the chimney is clean and free of any remaining debris or creosote. The technician will also check for any signs of damage that may have been hidden by the buildup, providing recommendations for any necessary <a href="/service/Chimney-Repair">repairs</a> or <a href="/service/Chimney-Maintenance">maintenance</a>.</p><p><strong>6. Cleanup</strong></p><p>The technician will clean up the work area, ensuring that your home is left in the same condition as before the cleaning process began. This includes vacuuming up any loose debris and removing protective coverings.</p><h4>How BHO Chimney Sweepn Help</h4><p>BHO Chimney Sweep is a trusted provider of professional chimney cleaning services. With years of experience and a commitment to customer satisfaction, they offer comprehensive chimney that goes beyond basic cleaning. Here’s how theyn assist you with your chimney needs:</p><p><strong>1. Professional Expertise</strong></p><p>The team at BHO Chimney Sweep consists of certified and experienced technicians who are well-versed in all aspects of chimney cleaning and maintenance. Their expertise ensures that your chimney is cleaned thoroughly and safely, reducing the risk of fires and other hazards.</p><p><strong>2. Customized Cleaning Services</strong></p><p>BHO Chimney Sweep understands that every home and chimney is unique. They offer customized cleaning services tailored to your specific needs, whether you have a traditional wood-burning fireplace, a gas stove, or a more modern heating system. Their technicians take the time to understand your chimney's history and current condition, providing a personalized approach to ensure the best possiblere.</p><p><strong>3. Advanced Equipment</strong></p><p>Utilizing the latest tools and technology, BHO Chimney Sweep ensures a thorough and efficient cleaning process. Their advanced equipment allows them to reach every nook and cranny of your chimney, ensuring no creosote or debris is left behind. This includes specialized brushes, rods, and vacuums designed specifically for chimney cleaning.</p><p><strong>4. Comprehensive Services</strong></p><p>In addition to cleaning, BHO Chimney Sweep offers a wide range of related services to keep your chimney in top condition. These include <a href="/service/Chimney-Inspection">chimney inspections</a>, <a href="/service/Chimney-Repair">chimney repair</a>, <a href="/service/Chimney-Liner-Installation">chimney liner installation</a>, and <a href="/service/Chimney-Cap-Installation">chimneyp installation</a>. Their goal is to provide comprehensivere for your chimney, ensuring it remains safe and functional for years to come.</p><p><strong>5. Affordable Pricing</strong></p><p>BHO Chimney Sweep is committed to providing top-quality service at competitive prices. They offer transparent pricing with no hidden fees, ensuring you know exactly what you're paying for. Whether you need a basic cleaning or more extensive repairs, they work with you to find a solution that fits your budget.</p><p><strong>6. Convenient Scheduling</strong></p><p>Understanding that your time is valuable, BHO Chimney Sweep offers flexible scheduling options to fit your busy lifestyle. Youn easily book an appointment online through their <a href="/book">online scheduling page</a>, or younll them directly at <a href='866-501-1614'>866-501-1614</a> to speak with a representative. Their team is ready to assist you with any questions or concerns you might have.</p><p><strong>7. Satisfaction Guarantee</strong></p><p>BHO Chimney Sweep stands behind their work with a satisfaction guarantee, ensuring that you are completely happy with the service provided. They take pride in their reputation for reliability and customer service, making them the go-to choice for chimney cleaning.</p><h4>Why Choose BHO Chimney Sweep?</h4><p>Choosing BHO Chimney Sweep for your chimney cleaning needs means partnering with a company that values safety, quality, and customer service. Here are a few reasons why they stand out:</p><p><strong>Local Expertise</strong>: As a local business, BHO Chimney Sweep understands the unique needs of homeowners. They are familiar with local building codes, weather patterns, and common chimney issues in the area.</p><p><strong>Trustworthy Service</strong>: BHO Chimney Sweep has built a reputation for reliability and integrity. Their commitment to excellence ensures that your chimney is thoroughly cleaned, and any necessary repairs are performed to the highest standards.</p><p><strong>Comprehensivere</strong>: From initial cleaning to final inspections, BHO Chimney Sweep provides comprehensivere for your chimney. They offer a full range of services to address any issue that may arise, ensuring your chimney remains safe and efficient.</p><p><strong>Customer-Focused Approach</strong>: BHO Chimney Sweep puts their customers first, offering personalized service and attention to detail. They take the time to understand your needs and provide solutions that work for you.</p><h4>Conclusion</h4><p>Regular chimney cleaning is essential for maintaining a safe and efficient home heating system, particularly. By preventing chimney fires, improving air quality, enhancing heating efficiency, and prolonging the life of your chimney, this routine maintenance task is invaluable. BHO Chimney Sweep is here to help with expert services that ensure your chimney is clean, safe, and ready to use. Whether you need a routine cleaning or a comprehensive inspection, youn trust BHO Chimney Sweep to provide the quality service your home deserves. Contact them today to schedule your chimney cleaning and ensure your home remains safe and comfortable year-round.</p><h4>Keywords</h4><ol><li>Chimney cleaning</li><li>Professional chimney cleaning</li><li>Creosote removal BHO</li><li>Fireplace cleaning BHO</li><li>Chimney maintenance service</li><li>Chimney sweep BHO</li><li>Chimney safety BHO</li><li>Chimney repair</li><li>Chimney inspection BHO</li><li>BHO Chimney Sweep services</li></ol></div>
        `
    },
    {
      Title: "Chimney Sweep Services: Ensuring Safety and Efficiency with BHO Chimney Sweep",
      BlogPath: "Chimney Sweep Services: Ensuring Safety and Efficiency with BHO Chimney Sweep",
      tegoryPath: "chimney-sweep",
      category: "Chimney Sweep",
      Date: "Aug 02, 2022",
      Discription: "Chimneys are a cherished feature in many homes, providing warmth, comfort, and a cozy atmosphere during the cooler months. However, to keep your fireplace running safely and efficiently, regular chimney sweeping is essential. Chimney sweeping involves the removal of soot, creosote, and other debris thatn accumulate inside the chimney over time. Without regular maintenance, these buildupsn lead to dangerous conditions, including chimney fires and poor indoor air quality. In this comprehensive guide, we’ll discuss the importance of chimney sweeping, the process involved, and how BHO Chimney Sweepn assist you in keeping your chimney in optimal condition.",
      Photos: Chimney3,
      // Photos: blog1,
      BlogId: 4,
      BlogPathMenu: ["Chimney sweep", "Professional chimney sweeping", "Creosote removal BHO", "Chimney cleaning BHO", "Chimney safety", "Fireplace maintenance BHO", "Chimney inspection BHO", "Local chimney sweep services", "BHO Chimney Sweep", "Chimney efficiency BHO"],
      Text: `
<div class="markdown prose w-full break-words dark:prose-invert light"><h3>Chimney Sweep Services: Ensuring Safety and Efficiency with BHO Chimney Sweep</h3><p>Chimneys are a cherished feature in many homes, providing warmth, comfort, and a cozy atmosphere during the cooler months. However, to keep your fireplace running safely and efficiently, regular chimney sweeping is essential. Chimney sweeping involves the removal of soot, creosote, and other debris thatn accumulate inside the chimney over time. Without regular maintenance, these buildupsn lead to dangerous conditions, including chimney fires and poor indoor air quality. In this comprehensive guide, we’ll discuss the importance of chimney sweeping, the process involved, and how BHO Chimney Sweepn assist you in keeping your chimney in optimal condition.</p><h4>The Importance of Chimney Sweeping</h4><p><strong>1. Fire Prevention</strong></p><p>One of the most critical reasons to have your chimney regularly swept is to prevent chimney fires. Creosote, a highly flammable byproduct of burning wood,n accumulate on the walls of your chimney. If the buildup becomes too thick, itn easily ignite anduse a chimney fire that could spread to the rest of your home. Regular chimney sweeping removes creosote and reduces the risk of such fires, making it a vital safety measure for any household with a fireplace.</p><p><strong>2. Improved Air Quality</strong></p><p>A dirty chimneyn negatively impact the air quality inside your home. When the chimney is clogged with soot, creosote, or other debris, itn obstruct the flow of smoke and harmful gases, such asrbon monoxide, out of your home. Thisn lead to a dangerous buildup of these gases inside your living space, posing serious health risks to you and your family. Regular chimney sweeping ensures that your chimney is clear and functioning correctly, helping to maintain healthy indoor air quality.</p><p><strong>3. Enhanced Heating Efficiency</strong></p><p>A clean chimney is crucial for the efficient operation of your fireplace or stove. When your chimney is free of blockages and creosote buildup, it allows for better airflow, which in turn leads to more efficient combustion. This means that your fireplace will generate more heat while using less fuel, saving you money on heating costs. Regular sweeping ensures that your fireplace remains an effective and economical source of warmth.</p><p><strong>4. Prolonging Chimney Life</strong></p><p>Routine chimney sweeping helps to extend the life of your chimney by preventing the accumulation of corrosive substances like creosote and soot. These substancesn damage the chimney’s lining and masonry over time, leading to costly repairs or even the need for a full chimney rebuild. By keeping your chimney clean, youn avoid these issues and ensure that your chimney lasts for many years to come.</p><p><strong>5. Compliance with Local Regulations</strong></p><p>local building codes and insurance policies may require regular chimney maintenance, including sweeping. Adhering to these regulations not only helps you avoid potential fines but also ensures that your home remains insurable in the event of a chimney-related incident. Regular chimney sweeping is an essential part of maintaining compliance with local requirements and protecting your investment in your home.</p><h4>The Chimney Sweeping Process</h4><p>Understanding the chimney sweeping processn help you appreciate the importance of this service and what to expect when you hire BHO Chimney Sweep.</p><p><strong>1. Initial Inspection</strong></p><p>Before beginning the actual sweeping, the technician will conduct an initial inspection of your chimney to assess its condition. This includes checking for visible signs of damage, blockages, or excessive creosote buildup. The technician may also use specialized tools to examine the interior of the chimney more thoroughly.</p><p><strong>2. Protecting Your Home</strong></p><p>To ensure that your home remains clean during the sweeping process, the technician will take steps to protect the area around your fireplace. This typically involves covering the floor and furniture with drop cloths and setting up a vacuum system topture any debris that may be dislodged during the cleaning.</p><p><strong>3. Sweeping the Chimney</strong></p><p>The actual sweeping process involves using specialized brushes and rods to scrub the interior walls of the chimney, removing soot, creosote, and any other debris. The technician will work from both the top and bottom of the chimney to ensure that every part of the chimney is thoroughly cleaned. This process is essential for preventing the buildup of flammable materials and ensuring that the chimney functions correctly.</p><p><strong>4. Removing Blockages</strong></p><p>If the inspection revealed any blockages, such as nests, leaves, or other debris, the technician will remove them during the sweeping process. Blockagesn significantly impair the chimney’s ability to vent smoke and gases, so this step is crucial for maintaining proper airflow.</p><p><strong>5. Final Inspection</strong></p><p>After the sweeping is complete, the technician will conduct a final inspection to ensure that the chimney is clean and free of any remaining debris. This inspection also includes checking for any signs of damage or wear that may have been hidden by the soot and creosote. If any issues are identified, the technician will provide recommendations for <a href="/service/Chimney-Repair">repairs</a> or additional <a href="/service/Chimney-Maintenance">maintenance</a> services.</p><p><strong>6. Cleanup</strong></p><p>Once the sweeping and inspection are complete, the technician will clean up the work area, ensuring that your home is left in the same condition as before the service began. This includes vacuuming up any loose debris and removing the protective coverings.</p><h4>How BHO Chimney Sweepn Help</h4><p>BHO Chimney Sweep is a trusted provider of professional chimney sweeping services. With a team of experienced technicians and a commitment to customer satisfaction, they offer comprehensive chimney that goes beyond basic cleaning. Here’s how theyn assist you with your chimney needs:</p><p><strong>1. Experienced Technicians</strong></p><p>BHO Chimney Sweep employs certified and experienced technicians who are experts in chimney maintenance. Their knowledge and skills ensure that your chimney is thoroughly swept, and any potential issues are identified and addressed. Whether you need a routine sweeping or suspect a problem with your chimney, BHO Chimney Sweep has the expertise to provide the necessary services.</p><p><strong>2. Customized Service</strong></p><p>BHO Chimney Sweep understands that every chimney is unique, and they tailor their services to meet your specific needs. Whether you have a traditional wood-burning fireplace, a gas stove, or a more modern heating system, their technicians will provide a customized sweeping service that ensures your chimney is safe and efficient.</p><p><strong>3. Advanced Equipment</strong></p><p>BHO Chimney Sweep uses the latest tools and technology to provide a thorough and efficient sweeping process. Their advanced equipment allows them to reach every part of your chimney, ensuring that no soot, creosote, or debris is left behind. This includes specialized brushes for different types of chimneys and vacuums to keep your home clean during the service.</p><p><strong>4. Comprehensivere</strong></p><p>In addition to sweeping, BHO Chimney Sweep offers a full range of chimney services to keep your chimney in top condition. These include <a href="/service/Chimney-Inspection">chimney inspections</a>, <a href="/service/Chimney-Repair">chimney repairs</a>, <a href="/service/Chimney-Liner-Installation">chimney liner installation</a>, and <a href="/service/Chimney-Cap-Installation">chimneyp installation</a>. Their goal is to provide comprehensivere for your chimney, ensuring it remains safe and functional for years to come.</p><p><strong>5. Affordable Pricing</strong></p><p>BHO Chimney Sweep is committed to offering top-quality service at competitive prices. They provide transparent pricing with no hidden fees, ensuring that you know exactly what to expect. Whether you need a simple sweeping or more extensive chimney, they work with you to find a solution that fits your budget.</p><p><strong>6. Convenient Scheduling</strong></p><p>BHO Chimney Sweep offers flexible scheduling options to accommodate your busy lifestyle. Youn easily book an appointment online through their <a href="/book">online scheduling page</a>, or younll them directly at <a href='866-501-1614'>866-501-1614</a>. Their team is ready to assist you with any questions or concerns you might have and will work with you to find a time that fits your schedule.</p><p><strong>7. Satisfaction Guarantee</strong></p><p>BHO Chimney Sweep stands behind their work with a satisfaction guarantee, ensuring that you are completely happy with the service provided. They take pride in their reputation for reliability and customer service, making them the go-to choice for chimney sweeping in BHO.</p><h4>Why Choose BHO Chimney Sweep?</h4><p>When you choose BHO Chimney Sweep for your chimney sweeping needs, you’re partnering with a company that prioritizes safety, quality, and customer service. Here’s what sets them apart:</p><p><strong>Local Expertise</strong>: As a local business, BHO Chimney Sweep understands the unique needs of homeowners. They are familiar with the local building codes, weather patterns, and common chimney issues in the area, allowing them to provide the best possiblere for your chimney.</p><p><strong>Trustworthy Service</strong>: BHO Chimney Sweep has built a reputation for reliability and integrity. Their commitment to excellence ensures that your chimney is thoroughly swept, and any necessary repairs are performed to the highest standards.</p><p><strong>Comprehensivere</strong>: From initial inspection to final sweeping, BHO Chimney Sweep provides comprehensivere for your chimney. They offer a full range of services to address any issue that may arise, ensuring your chimney remains safe and efficient.</p><p><strong>Customer-Focused Approach</strong>: BHO Chimney Sweep puts their customers first, offering personalized service and attention to detail. They take the time to understand your needs and provide solutions that work for you.</p><h4>Conclusion</h4><p>Regular chimney sweeping is essential for maintaining the safety, efficiency, and longevity of your chimney, especially. By preventing chimney fires, improving air quality, enhancing heating efficiency, and prolonging the life of your chimney, this routine maintenance task is invaluable. BHO Chimney Sweep is here to help with expert services that ensure your chimney is clean, safe, and ready to use. Whether you need a routine sweeping or a comprehensive inspection, youn trust BHO Chimney Sweep to provide the quality service your home deserves. Contact them today to schedule your chimney sweeping and ensure your home remains safe and comfortable year-round.</p><h4>Keywords</h4><ol><li>Chimney sweep</li><li>Professional chimney sweeping</li><li>Chimney cleaning BHO</li><li>Creosote removal BHO</li><li>Fireplace maintenance BHO</li><li>Chimney safety</li><li>Local chimney sweep services</li><li>Chimney inspection BHO</li><li>Chimney efficiency BHO</li><li>BHO Chimney Sweep</li></ol></div>
        `
    }
  ]);
  // Faq
  const [FaqList, setFaqList] = useState([

    // Chimney Cleaning
    {
      question: "How often should I have my chimney cleaned",
      questionPath: "How often should I have my chimney cleaned",
      answer: "It's recommended to have your chimney cleaned at least once a year, especially if you use your fireplace frequently. More frequent cleaning may be necessary if you burn a lot of wood or use your fireplace heavily.",
      category: "Chimney Cleaning",
      faqId: 1
    },

    {
      question: "What are the signs that my chimney needs cleaning",
      questionPath: "What are the signs that my chimney needs cleaning",
      answer: "Common signs include a strong odor from the fireplace, poor draft (smoke entering your home), and visible soot or creosote buildup inside the chimney. If you notice these, it’s time for a cleaning.",
      category: "Chimney Cleaning",
      faqId: 2
    },

    {
      question: "Can I clean my chimney myself",
      questionPath: "Can I clean my chimney myself",
      answer: "While DIY chimney cleaning kits are available, it’s best to hire a professional for a thorough and safe cleaning. Professionals have the tools and experience to remove creosote buildup effectively.",
      category: "Chimney Cleaning",
      faqId: 3
    },

    {
      question: "What is creosote, and why is it dangerous",
      questionPath: "What is creosote, and why is it dangerous",
      answer: "Creosote is a byproduct of burning wood that accumulates inside your chimney. It’s highly flammable andnuse dangerous chimney fires if not regularly cleaned.",
      category: "Chimney Cleaning",
      faqId: 4
    },

    {
      question: "Does chimney cleaning prevent chimney fires",
      questionPath: "Does chimney cleaning prevent chimney fires",
      answer: "Yes, regular chimney cleaning significantly reduces the risk of chimney fires by removing flammable creosote and blockages thatn lead to overheating.",
      category: "Chimney Cleaning",
      faqId: 5
    },

    // Chimney Inspection
    {
      question: "What is the purpose of a chimney inspection",
      questionPath: "What is the purpose of a chimney inspection",
      answer: "A chimney inspection ensures that your chimney is safe to use by identifying any structural damage, blockages, or buildup that could pose a fire hazard or affect performance.",
      category: "Chimney Inspection",
      faqId: 6
    },

    {
      question: "How often should I have a chimney inspection",
      questionPath: "How often should I have a chimney inspection",
      answer: "An annual chimney inspection is recommended, especially if you use your fireplace regularly. Inspections are crucial for detecting issues before they become serious.",
      category: "Chimney Inspection",
      faqId: 7
    },

    {
      question: "What’s the difference between a Level 1, 2, and 3 chimney inspection",
      questionPath: "What’s the difference between a Level 1, 2, and 3 chimney inspection",
      answer: "Level 1 is a basic inspection, Level 2 includes a video scan of the chimney, and Level 3 involves more invasive methods if serious issues are suspected, such as removing parts of the chimney or surrounding structure.",
      category: "Chimney Inspection",
      faqId: 8
    },

    {
      question: "What should I do if my chimney fails inspection",
      questionPath: "What should I do if my chimney fails inspection",
      answer: "If your chimney fails inspection, follow the recommendations provided by the inspector. This may include repairs, cleaning, or further investigation to ensure your chimney is safe.",
      category: "Chimney Inspection",
      faqId: 9
    },

    {
      question: "Can a chimney inspection detectrbon monoxide issues",
      questionPath: "Can a chimney inspection detectrbon monoxide issues",
      answer: "Yes, a thorough inspectionn identify blockages or ventilation problems that could lead torbon monoxide buildup, ensuring your home’s air quality is safe.",
      category: "Chimney Inspection",
      faqId: 10
    },

    // Chimney Repair
    {
      question: "What are common chimney repairs",
      questionPath: "What are common chimney repairs",
      answer: "Common repairs include fixing cracks in the masonry, repairing or replacing the chimney crown, relining the flue, and addressing water leaks or damageused by moisture.",
      category: "Chimney Repair",
      faqId: 11
    },

    {
      question: "How do I know if my chimney needs repair",
      questionPath: "How do I know if my chimney needs repair",
      answer: "Signs your chimney needs repair include visible cracks, crumbling mortar, water leaks, a damaged chimneyp or crown, and poor draft (smoke not venting properly).",
      category: "Chimney Repair",
      faqId: 12
    },

    {
      question: "How much do chimney repairs typically cost",
      questionPath: "How much do chimney repairs typically cost",
      answer: "The cost of chimney repairs varies depending on the extent of the damage. Minor repairs might cost a few hundred dollars, while major repairs, like relining,n run into the thousands.",
      category: "Chimney Repair",
      faqId: 13
    },

    {
      question: "How long does chimney repair take",
      questionPath: "How long does chimney repair take",
      answer: "The time required for chimney repair depends on the scope of the work. Minor repairs might take a few hours, while more extensive work, like rebuilding,n take several days.",
      category: "Chimney Repair",
      faqId: 14
    },

    {
      question: "Can chimney repairs be done year-round",
      questionPath: "Can chimney repairs be done year-round",
      answer: "Yes, most chimney repairsn be done year-round, but it’s ideal to schedule them during the warmer months to avoid potential issues with weather and fireplace use.",
      category: "Chimney Repair",
      faqId: 15
    },

    // Chimney Sweep
    {
      question: "What does a chimney sweep do",
      questionPath: "What does a chimney sweep do",
      answer: "A chimney sweep removes soot, creosote, and blockages from the inside of the chimney, ensuring safe and efficient operation of your fireplace or stove.",
      category: "Chimney Sweep",
      faqId: 16
    },

    {
      question: "How often should I schedule a chimney sweep",
      questionPath: "How often should I schedule a chimney sweep",
      answer: "It’s recommended to have your chimney swept annually, especially if you use your fireplace frequently. More frequent sweeps may be necessary depending on usage.",
      category: "Chimney Sweep",
      faqId: 17
    },

    {
      question: "What’s the difference between a chimney sweep and a chimney cleaning",
      questionPath: "What’s the difference between a chimney sweep and a chimney cleaning",
      answer: "The terms are often used interchangeably, but generally, a chimney sweep refers to the professional service, while chimney cleaning refers to the actual process of removing soot and debris.",
      category: "Chimney Sweep",
      faqId: 18
    },

    {
      question: "Hown I prepare for a chimney sweep visit",
      questionPath: "Hown I prepare for a chimney sweep visit",
      answer: "Before the sweep arrives, clear the area around your fireplace, cover furniture to protect from dust, and avoid using the fireplace for at least 24 hours prior.",
      category: "Chimney Sweep",
      faqId: 19
    },

    {
      question: "Is a chimney sweep messy",
      questionPath: "Is a chimney sweep messy",
      answer: "Professional chimney sweeps take precautions to minimize mess, using drop cloths and vacuums to keep your home clean during the process.",
      category: "Chimney Sweep",
      faqId: 20
    },

    // Chimney Liner Installation
    {
      question: "What is a chimney liner",
      questionPath: "What is a chimney liner",
      answer: "A chimney liner is a protective barrier inside the chimney that helps contain the combustion byproducts, protects the chimney walls from heat and corrosion, and improves draft.",
      category: "Chimney Liner Installation",
      faqId: 21
    },

    {
      question: "Why might I need a new chimney liner",
      questionPath: "Why might I need a new chimney liner",
      answer: "You may need a new liner if your current liner is damaged, missing, or incompatible with your heating appliance. A new linern also improve safety and efficiency.",
      category: "Chimney Liner Installation",
      faqId: 22
    },

    {
      question: "How long does chimney liner installation take",
      questionPath: "How long does chimney liner installation take",
      answer: "The installation of a chimney liner typically takes a few hours to a full day, depending on the complexity of the chimney and the type of liner being installed.",
      category: "Chimney Liner Installation",
      faqId: 23
    },

    {
      question: "What types of chimney liners are available",
      questionPath: "What types of chimney liners are available",
      answer: "Common types of chimney liners include clay tile, metal (stainless steel or aluminum), andst-in-place liners, each with its own benefits depending on your chimney’s needs.",
      category: "Chimney Liner Installation",
      faqId: 24
    },

    {
      question: "How much does chimney liner installation cost",
      questionPath: "How much does chimney liner installation cost",
      answer: "The cost of installing a chimney liner varies based on the material and the complexity of the installation, typically ranging from $1,000 to $3,000.",
      category: "Chimney Liner Installation",
      faqId: 25
    },

    // Chimney Crown Repair
    {
      question: "What is a chimney crown",
      questionPath: "What is a chimney crown",
      answer: "A chimney crown is the concrete slab or masonryp that covers the top of your chimney, protecting it from water damage by directing rain and snow away from the chimney structure.",
      category: "Chimney Crown Repair",
      faqId: 26,
    },

    {
      question: "How do I know if my chimney crown needs repair",
      questionPath: "How do I know if my chimney crown needs repair",
      answer: "Signs that your chimney crown needs repair include visible cracks, crumbling concrete, water leaks, and moss or vegetation growth on the crown.",
      category: "Chimney Crown Repair",
      faqId: 27,
    },

    {
      question: "What happens if I don’t repair a damaged chimney crown",
      questionPath: "What happens if I don’t repair a damaged chimney crown",
      answer: "Neglecting a damaged crownn lead to serious water damage, including leaks, chimney deterioration, and even structural damage to your home.",
      category: "Chimney Crown Repair",
      faqId: 28,
    },

    {
      question: "How long does chimney crown repair take",
      questionPath: "How long does chimney crown repair take",
      answer: "Chimney crown repair usually takes a few hours to a day, depending on the extent of the damage and whether a full replacement is needed.",
      category: "Chimney Crown Repair",
      faqId: 29,
    },

    {
      question: "Can a chimney crown be replaced",
      questionPath: "Can a chimney crown be replaced",
      answer: "Yes, if the crown is severely damaged or deteriorated, a full replacement may be necessary to ensure proper protection for your chimney.",
      category: "Chimney Crown Repair",
      faqId: 30,
    },

    // Chimney Draft Issues
    {
      question: "Whatuses chimney draft issues",
      questionPath: "Whatuses chimney draft issues",
      answer: "Commonuses of chimney draft issues include blockages, improper chimney height, air pressure differences, and a lack of proper ventilation or chimneyp.",
      category: "Chimney Draft Issues",
      faqId: 31,
    },

    {
      question: "Hown I tell if I have a chimney draft problem",
      questionPath: "Hown I tell if I have a chimney draft problem",
      answer: "Signs of a draft problem include smoke entering your home instead of exiting through the chimney, a fireplace that doesn’t stay lit, and strong odors from the fireplace.",
      category: "Chimney Draft Issues",
      faqId: 32,
    },

    {
      question: "Can a chimneyp help with draft issues",
      questionPath: "Can a chimneyp help with draft issues",
      answer: "Yes, installing a chimneypn help with draft issues by preventing downdrafts and keeping debris and animals out of the chimney.",
      category: "Chimney Draft Issues",
      faqId: 33,
    },

    {
      question: "Hown chimney draft issues be fixed",
      questionPath: "Hown chimney draft issues be fixed",
      answer: "Fixing draft issues may involve cleaning blockages, adjusting the chimney height, improving ventilation, or installing a draft-inducing device or chimneyp.",
      category: "Chimney Draft Issues",
      faqId: 34,
    },

    {
      question: "Are draft issues more common in older homes",
      questionPath: "Are draft issues more common in older homes",
      answer: "Draft issuesn occur in any home, but older homes may be more susceptible due to outdated chimney designs, wear and tear, or settling of the structure.",
      category: "Chimney Draft Issues",
      faqId: 35,
    },
  ]);
  // WebSitePages
  const [WebSitePages, setWebSitePages] = useState([
    // Resources
    {
      Name: "Home Page",
      Path: "/",
      category: "Resources"
    },
    {
      Name: "Apply Now",
      Path: "/apply",
      category: "Resources"
    },
    {
      Name: "Contact",
      Path: "/contact",
      category: "Resources"
    },
    {
      Name: "Blog",
      Path: "/blog",
      category: "Resources"
    },
    {
      Name: "Faq",
      Path: "/faq",
      category: "Resources"
    },
    // Aboout Us
    {
      Name: "Success Stories",
      Path: "/successstories",
      category: "About Us"
    },
    {
      Name: "Links",
      Path: "/links",
      category: "About Us"
    },

    // Servcies
    {
      Name: "Business Line of Credit",
      Path: "/business-line-of-credit",
      category: "Sulotion"
    },
    {
      Name: "Business Term Loan",
      Path: "/long-term-loan",
      category: "Sulotion"
    },
    {
      Name: "Small Business Loan",
      Path: "/sba-loan",
      category: "Sulotion"
    },
    {
      Name: "Same Day Funding",
      Path: "/same-day-funding",
      category: "Sulotion"
    },
    {
      Name: "Privacy Policy",
      Path: "/privacypolicy",
      category: "About"
    },
    {
      Name: "Terms Conditions",
      Path: "/termsconditions",
      category: "About"
    },
    {
      Name: "Site Map",
      Path: "/sitemap",
      category: "About"
    },
  ]);
  const navigateTo = (page) => {
    navigate('/' + page)
    setShowMenu(false)

  }

  return (
    <div className="App" style={false ? { "document.html.style.overflow": "hidden" } : null}>

      <Offline>
        <div className="OfflineApp">
          <h1><img src={unlock} alt="Chimney Sweep | Chimney Repair | Chimney Services | Chimney Inspection" /><span>Internet Connection Is Not Stable.</span>Your network seems to be disconnected. Please check your internet connection.</h1>
          <img onClick={() => window.location.reload()} className='OfflineAppClose' src={reload} alt="Chimney Sweep | Chimney Repair | Chimney Services | Chimney Inspection" />
        </div>
      </Offline>

      {/* Book an appointment */}
      {showPopUp ?
        <PopUp CitiePhone={CitiePhone} CitiesData={CitiesData} setShowPopUp={setShowPopUp} />
        : null}
      {/* Menu */}
      {showMenu ? <Menu CitiePhone={CitiePhone} WebSitePages={WebSitePages} navigateTo={navigateTo} setShowMenu={setShowMenu} /> : null}
      {/* Header */}
      {location.pathname == "/apply" || location.pathname == "/thankscontact" || location.pathname == "/thanks" || location.pathname.match("/portal/:*") ? null : <Header CitiePhone={CitiePhone} CitiesData={CitiesData} setShowPopUp={setShowPopUp} WebSitePages={WebSitePages} showMenu={showMenu} navigateTo={navigateTo} setShowMenu={setShowMenu} />}
      {/* Main */}
      <Main locationsMainAirDuct={locationsMainAirDuct} locationsMain={locationsMain} CitiePhone={CitiePhone} CitiesData={CitiesData} FaqList={FaqList} WebSitePages={WebSitePages} Blogs={Blogs} navigateTo={navigateTo} />
      {/* Footer */}
      {location.pathname.startsWith("/book") || location.pathname.startsWith("/local") || location.pathname == "/thanks" || location.pathname == "/thankscontact" || location.pathname.match("/portal/:*") ? null : <Footer CitiePhone={CitiePhone} WebSitePages={WebSitePages} navigateTo={navigateTo} />}

      {/* oNLINE */}
      {location.pathname == "/book" ? null : <a className='callButtonMainApp' href={`tel:${CitiePhone}`}> <img src={callbtn} alt="" />Click To Call!</a>}


    </div>
  );
}

export default App;
